import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import type { ContextPreviewProps } from '../common/context-preview';
import { TemplateSelector } from '../messaging/components/template-selector/template-selector';
import { EmailArea } from './components/email-area';
import { Header } from './components/header';
import { useEmailStates } from './hooks/useEmailStates';

type EmailViewProps = {
  states: ReturnType<typeof useEmailStates>;
  contextPreviewProps?: ContextPreviewProps;
};
export const EmailView = ({ states, contextPreviewProps }: EmailViewProps) => {
  const isMobile = useMatchMedia({ maxWidth: breakpoints.small.min });
  const {
    locationId,
    getFieldProps,
    person,
    setAttachments,
    toField,
    setToField,
    templateSelection,
    templateType,
    onSettingsOpen,
  } = states;
  const [showTemplateSelection, setShowTemplateSelection] = templateSelection;

  if (showTemplateSelection) {
    return (
      <div
        css={{
          padding: isMobile ? theme.spacing(3) : '0px',
        }}
      >
        <TemplateSelector
          groupIds={[locationId]}
          templateTypes={[templateType]}
          onSelectTemplate={(template) => {
            states.renderTemplate(template);
            setShowTemplateSelection(false);
          }}
          onOpenSettings={onSettingsOpen}
        />
      </div>
    );
  }

  return (
    <div
      css={{
        height: 'min-content',
        border: isMobile ? '0px' : `1px solid ${theme.colors.neutral20}`,
        borderRadius: theme.borderRadius.medium,
      }}
    >
      {person && <Header person={person} contextPreviewProps={contextPreviewProps} isMobile={isMobile} />}
      <EmailArea
        person={person}
        locationId={locationId}
        getFieldProps={getFieldProps}
        setAttachments={setAttachments}
        toField={toField}
        setToField={setToField}
        isMobile={isMobile}
        onSelectTemplate={() => setShowTemplateSelection(true)}
      />
    </div>
  );
};
